module.exports = __webpack_public_path__ + "img/fr-ds.70ba40bc.svg";